import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-sm font-semibold mb-4">カテゴリ</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/free" className="hover:text-white transition-colors">
                  年会費無料
                </Link>
              </li>
              <li>
                <Link to="/highreturn" className="hover:text-white transition-colors">
                  高還元率
                </Link>
              </li>
              <li>
                <Link to="/instant" className="hover:text-white transition-colors">
                  即日発行
                </Link>
              </li>
              <li>
                <Link to="/student" className="hover:text-white transition-colors">
                  学生向け
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4">人気ページ</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/ranking" className="hover:text-white transition-colors">
                  人気ランキング
                </Link>
              </li>
              <li>
                <Link to="/comparison" className="hover:text-white transition-colors">
                  比較一覧
                </Link>
              </li>
              <li>
                <Link to="/diagnosis" className="hover:text-white transition-colors">
                  無料診断
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4">利用シーン別</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/use-cases/travel" className="hover:text-white transition-colors">
                  海外旅行
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4">サイト情報</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  ホーム
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            © 2026 クレカスタート. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
